export default __webpack_public_path__ + "static/media/Discover.5ca0babd.png";